module.exports = __webpack_public_path__ + "img/InvestSJ.c503d351.jpg";